<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-row>
            <v-col cols="12" md="8">
              <div>
                <v-text-field v-model="fields['title']" label="Name" />
              </div>
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox small v-model="fields['enableAnchor']" label="Enable Anchor" />
            </v-col>
          </v-row>
        </div>

        <div>
          <div class="label-input">Section Background</div>
          <div class="mb-5 group-item">
            <v-row>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.backgroundColor"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields.backgroundColor" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.textColor"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields.textColor" label="Text Color" />
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.top" label="Top Padding" />
                </div>
              </v-col>
              <v-col md="6" cols="12">
                <div class="d-flex align-center">
                  <v-checkbox v-model="fields.padding.bottom" label="Bottom Padding" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="label-input">Header Section</div>
          <div class="group-item mb-5">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label for="showHeader" style="margin-bottom: 0" class="">Show</label>
              <input type="checkbox" v-model="fields.headerSection.show" id="showHeader" />
            </div>
            <ckeditor :editor="editor" v-model="fields.headerSection.text" :config="editorConfig" />
          </div>
        </div>

        <div>
          <div class="label-input">Before</div>
          <div class="group-item mb-5">
            <div class="mb-5">
              <label class="font-weight-bold">Image</label>
              <UploadImage
                @callback="obj => handleUploadBeforeImage(obj)"
                :image="{ imageSrc: fields.before.image }"
                :height="`250`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveBeforeImage"
              />
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.before.textLabel" label="Text Label" />
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="before-background-color-label"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.before.backgroundColorLabel"
                    @change="event => handleChangeBeforeBackgroundColorLabel(event)"
                  />
                  <v-text-field v-model="fields.before.backgroundColorLabel" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="before-color-label"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.before.colorLabel"
                    @change="event => handleChangeBeforeColorLabel(event)"
                  />
                  <v-text-field v-model="fields.before.colorLabel" label="Text Color" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="label-input">After</div>
          <div class="group-item mb-5">
            <div class="mb-5">
              <label class="font-weight-bold">Image</label>
              <UploadImage
                @callback="obj => handleUploadAfterImage(obj)"
                :image="{ imageSrc: fields.after.image }"
                :height="`250`"
                :typeUpload="'image'"
                @callbackDelete="handleRemoveAfterImage"
              />
            </div>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.after.textLabel" label="Text Label" />
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="after-background-color-label"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.after.backgroundColorLabel"
                    @change="event => handleChangeAfterBackgroundColorLabel(event)"
                  />
                  <v-text-field v-model="fields.after.backgroundColorLabel" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="3">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="after-color-label"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.after.colorLabel"
                    @change="event => handleChangeAfterColorLabel(event)"
                  />
                  <v-text-field v-model="fields.after.colorLabel" label="Text Color" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div class="label-input">Summary Section</div>
          <div class="group-item mb-5">
            <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
              <label for="showSummary" style="margin-bottom: 0" class="">Show</label>
              <input type="checkbox" v-model="fields.summarySection.show" id="showSummary" />
            </div>
            <ckeditor :editor="editor" v-model="fields.summarySection.text" :config="editorConfig" />
            <v-row class="mt-3">
              <v-col cols="12" md="4">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="summary-border-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.summarySection.borderColor"
                    @change="handleChangeSummaryBorderColor"
                  />
                  <v-text-field v-model="fields.summarySection.borderColor" label="Border Color" />
                </div>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field v-model="fields.summarySection.borderWidth" label="Border Width" />
              </v-col>
              <v-col cols="12" md="4">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="summary-background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.summarySection.backgroundColor"
                    @change="handleChangeSummaryBackgroundColor"
                  />
                  <v-text-field v-model="fields.summarySection.backgroundColor" label="Background Color" />
                </div>
              </v-col>
            </v-row>
          </div>
        </div>

        <div>
          <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
            <label for="showButton" style="margin-bottom: 0" class="label-input">Button</label>
            <input type="checkbox" v-model="fields.button.show" id="showButton" />
          </div>
          <div class="group-item mb-5" v-if="fields.button.show">
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.text" label="Button Text" />
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field v-model="fields.button.link" label="Button Link" />
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-background-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.backgroundColor"
                    @change="handleChangeButtonBackground"
                  />
                  <v-text-field v-model="fields.button.backgroundColor" label="Background Color" />
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="button-text-color"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields.button.color"
                    @change="handleChangeButtonTextColor"
                  />
                  <v-text-field v-model="fields.button.color" label="Text Color" />
                </div>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="fields.button.subBtn" label="Sub Button Text" />
              </v-col>
            </v-row>
          </div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '@/views/website/products/components/description/common/html/update';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
export default {
  name: 'CardCompareB1',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: 'Card Compare B1 Section',
        backgroundColor: '#ffffff',
        textColor: '#000000',
        enableAnchor: false,
        padding: {
          top: true,
          bottom: true,
        },
        headerSection: {
          show: true,
          text: '',
        },
        before: {
          image: '',
          textLabel: '',
          backgroundColorLabel: '#17d4f4',
          colorLabel: '#ffffff',
        },
        after: {
          image: '',
          textLabel: '',
          backgroundColorLabel: '#17d4f4',
          colorLabel: '#ffffff',
        },
        summarySection: {
          show: true,
          text: '',
          borderColor: '#17d4f4',
          borderWidth: '1px',
          backgroundColor: '#ffffff',
        },
        button: {
          text: 'LIGHTEN UP YOUR SPACE NOW',
          backgroundColor: '#aa6d32',
          color: '#ffffff',
          show: true,
          link: '#',
          subBtn: 'Get faster shipping when you buy 2+',
        },
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardCompareB1(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleChangeBackgroundColor(event) {
      this.fields.backgroundColor = event.target.value;
    },
    handleChangeTextColor(event) {
      this.fields.textColor = event.target.value;
    },
    handleUploadBeforeImage(obj) {
      this.fields.before.image = obj.imageSrc;
    },
    handleRemoveBeforeImage() {
      this.fields.before.image = '';
    },
    handleChangeBeforeBackgroundColorLabel(event) {
      this.fields.before.backgroundColorLabel = event.target.value;
    },
    handleChangeBeforeColorLabel(event) {
      this.fields.before.colorLabel = event.target.value;
    },
    handleUploadAfterImage(obj) {
      this.fields.after.image = obj.imageSrc;
    },
    handleRemoveAfterImage() {
      this.fields.after.image = '';
    },
    handleChangeAfterBackgroundColorLabel(event) {
      this.fields.after.backgroundColorLabel = event.target.value;
    },
    handleChangeAfterColorLabel(event) {
      this.fields.after.colorLabel = event.target.value;
    },
    handleChangeSummaryBorderColor(event) {
      this.fields.summarySection.borderColor = event.target.value;
    },
    handleChangeSummaryBackgroundColor(event) {
      this.fields.summarySection.backgroundColor = event.target.value;
    },
    handleChangeButtonBackground(event) {
      this.fields.button.backgroundColor = event.target.value;
    },
    handleChangeButtonTextColor(event) {
      this.fields.button.color = event.target.value;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .ck-editor__editable_inline {
  min-height: 120px;
}
::v-deep .ck-editor__editable {
  min-height: 120px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
